const planName = {
  FREE_PLAN: 'free',
  ENTERPRISE_PLAN: 'enterprise',
  CUSTOM_PLAN: 'custom',
  LITE_PLAN: 'lite',
  GROWTH_PLAN: 'growth',
};

export default planName;
